/** The header control that changes only the current interface language. */

import { SUPPORTED_LOCALES, useI18n } from '../i18n'
import type { Locale } from '../types/domain'
import './LangSwitch.css'

const LABELS: Record<string, string> = { fr: 'FR', nl: 'NL', en: 'EN' }

export function LangSwitch() {
  const { locale, setLocale, t } = useI18n()

  const choose = (code: Locale) => {
    // PIVOT-159 option 1: the header changes only the interface. The stored
    // locale remains the onboarding language that background jobs carry.
    setLocale(code)
  }

  return (
    <div className="lang-switch" role="group" aria-label={t('a11y.languageSwitch')}>
      {SUPPORTED_LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          className={code === locale ? 'active' : ''}
          aria-pressed={code === locale}
          onClick={() => choose(code)}
        >
          {LABELS[code]}
        </button>
      ))}
    </div>
  )
}
